// import React, { useState, useRef, useEffect } from 'react';
// import { apiCall } from '@/api/apiCall';
// import { toast } from 'sonner';
// import { useApiQueue } from '@/hooks/useApiQueue';
// import LOGO from '@/assets/img/Jeddah_1.png';
// import CarPark from '@/assets/img/TaifContract-carPark.png';
// import OnStreet from '@/assets/img/TaifContract-onStreet.png';
// import Enforcement from '@/assets/img/TaifContract-Enforcement.png';
// import { AssetsPanel } from '../../components/shared/AssetsPanel';
// import { API_CALL_TIME } from '@/constants/constant';

// // ═══════════════════════════════════════════════════════════════════════
// // HELPERS
// // ═══════════════════════════════════════════════════════════════════════
// const groupsToFlat = (groups = []) => {
//   const result = [];
//   groups.forEach(g => {
//     result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
//     (g.items || []).forEach(item => {
//       result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
//     });
//   });
//   return result;
// };

// const flatToGroups = (flat) => {
//   const groups = [];
//   let cur = null;
//   flat.forEach(a => {
//     if (a.isCategory) {
//       if (cur) groups.push(cur);
//       cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
//     } else if (cur) {
//       cur.items.push({ item_name: a.name, qty: a.subCount || '' });
//     }
//   });
//   if (cur) groups.push(cur);
//   return groups;
// };

// // ═══════════════════════════════════════════════════════════════════════
// // ASSET GROUPS HELPER
// // ═══════════════════════════════════════════════════════════════════════
// function makeAssetGroups(o = {}) {
//   return [
//     { group_name: 'Ticket Dispenser', group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
//     { group_name: 'Ticket Verifier', group_total_qty: o.ticketVerifier ?? '', items: [{ item_name: 'EV DIP G100', qty: o.evDipG100 ?? '-' }, { item_name: 'EV G100 64 Bit', qty: '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
//     { group_name: "APM's", group_total_qty: o.apms ?? '-', items: [{ item_name: 'APM ETS-70', qty: '-' }, { item_name: 'APM ETS-100', qty: '-' }] },
//     { group_name: 'PIN Pad', group_total_qty: o.pinPad ?? '-', items: [{ item_name: 'IUP 250', qty: '-' }] },
//     { group_name: 'Card Reader', group_total_qty: o.cardReader ?? '-', items: [{ item_name: 'IUR250', qty: '-' }] },
//     { group_name: 'B-Contactless', group_total_qty: o.bContactless ?? '-', items: [{ item_name: 'IUC 150', qty: '-' }] },
//     { group_name: 'RFID Reader', group_total_qty: o.rfidReader ?? '-', items: [] },
//     { group_name: 'IP Barrier', group_total_qty: o.ipBarrier ?? '-', items: [] },
//     { group_name: 'ANPR CAMERA', group_total_qty: o.anprCamera ?? '-', items: [{ item_name: 'ARH', qty: '-' }, { item_name: 'Luminera', qty: '-' }] },
//     { group_name: 'Sliding Gate', group_total_qty: o.slidingGate ?? '-', items: [{ item_name: 'RIGHT', qty: o.right ?? '-' }, { item_name: 'LEFT', qty: o.left ?? '-' }] },
//     { group_name: "PND's", group_total_qty: o.pnds ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: o.tpalBnaLarge ?? '-' }, { item_name: 'T-PAL TX', qty: o.tpalTx ?? '-' }, { item_name: 'T-PAL V2', qty: o.tpalV2 ?? '-' }] },
//     { group_name: 'Pound Cahier Device', group_total_qty: '-', items: [{ item_name: 'CN-50', qty: '-' }] },
//     { group_name: 'Driver Device', group_total_qty: '-', items: [{ item_name: 'CN-51', qty: '-' }] },
//     { group_name: 'Enf Device', group_total_qty: o.enfDevice ?? '-', items: [{ item_name: 'Oukitel WP 2', qty: o.oukitelWp2 ?? '-' }, { item_name: 'Doogee V10', qty: o.doogeeV10 ?? '-' }] },
//     { group_name: 'Validation', group_total_qty: '-', items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
//     { group_name: 'Printer', group_total_qty: o.printer ?? '-', items: [{ item_name: 'PR-3', qty: o.pr3 ?? '-' }, { item_name: 'SEWOO', qty: o.sewoo ?? '-' }, { item_name: 'BIXOLON', qty: o.bixolon ?? '-' }] },
//     { group_name: 'Tow Truck', group_total_qty: o.towTruck ?? '-', items: [] },
//     { group_name: 'Clamp Vehicle', group_total_qty: o.clampVehicle ?? '-', items: [] },
//     { group_name: 'Support Vehicle', group_total_qty: o.supportVehicle ?? '-', items: [] },
//   ];
// }

// // ═══════════════════════════════════════════════════════════════════════
// // CONFIG
// // ═══════════════════════════════════════════════════════════════════════
// const JEDDAH_PROFILE_CONFIG = {

//   // ── Jeddah On-Street ─────────────────────────────────────────────────
//   jeddah_on_street_profile: {
//     profileKey: 'jeddah_on_street_profile',
//     violationKey: 'jeddah_on_street_violations',
//     assetsKey: 'jeddah_on_street_assets',
//     pageType: 'on_street',

//     profileFallback: {
//       table_key: 'jeddah_on_street_profile',
//       title: 'Jeddah On Street - Profile',
//       data: {
//         total_bays: { label: 'Total On-Street Parking', value: '8,858' },
//         contract_term: { value: '25 years' },
//         contract_period: { start_date: '12.11.2014', end_date: '11.11.2039' },
//         operational_hours: { value: '15 Hours Per day', from: '0800', to: '2300' },
//         rate_per_hour: { value: 'SAR 4.00 plus 15% vat' },
//         ramadan_hours: { value: '11:00 Hours to 17:00 Hours & 21:00 Hours to 03:00 Hours' },
//       },
//     },

//     violationFallback: {
//       table_key: 'jeddah_on_street_violations',
//       title: 'Jeddah On Street Violations',
//       data: {
//         rows: [
//           { city_code: 'JED', violation_code: '10', violation_name: 'Parked without displaying a valid parking ticket', ticket_charges: 'SAR 150', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
//           { city_code: 'JED', violation_code: '11', violation_name: 'Parking a vehicle larger than the marked space', ticket_charges: 'SAR 150', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
//           { city_code: 'JED', violation_code: '12', violation_name: 'Parked with a wheel on pedestrian areas/road', ticket_charges: 'SAR 100', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
//           { city_code: 'JED', violation_code: '13', violation_name: 'Not parked within space markings', ticket_charges: 'SAR 100', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
//           { city_code: 'JED', violation_code: '14', violation_name: 'Parked/overhanging a loading/unloading space', ticket_charges: 'SAR 150', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
//           { city_code: 'JED', violation_code: '15', violation_name: 'Parked in a space for Special Needs without a valid permit', ticket_charges: 'SAR 150', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
//           { city_code: 'JED', violation_code: '16', violation_name: 'Parked without at least one license plate', ticket_charges: 'SAR 300', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
//           { city_code: 'JED', violation_code: '21', violation_name: 'Park in Sand Areas', ticket_charges: 'SAR 100', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
//           { city_code: 'JED', violation_code: '22', violation_name: 'Obstructing an authorized personnel from executing their duties', ticket_charges: 'SAR 300', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
//           { city_code: 'JED', violation_code: '801', violation_name: 'Parked within the road and traffic areas', ticket_charges: 'SAR 150', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
//           { city_code: 'JED', violation_code: '802', violation_name: 'Parked on pedestrian or buildings entries', ticket_charges: 'SAR 200', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
//           { city_code: 'JED', violation_code: '803', violation_name: 'Parked on the pavement or on a pedestrian area', ticket_charges: 'SAR 100', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
//           { city_code: 'JED', violation_code: '804', violation_name: 'Parked facing the opposite direction of traffic flow', ticket_charges: 'SAR 150', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
//           { city_code: 'JED', violation_code: '805', violation_name: 'Parked in an officially reserved space', ticket_charges: 'SAR 100', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
//           { city_code: 'JED', violation_code: '806', violation_name: 'Parked in a suspended space/temporary out of use', ticket_charges: 'SAR 150', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
//           { city_code: 'JED', violation_code: '807', violation_name: 'Placing obstacles or reservations on the parking space', ticket_charges: 'SAR 150', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
//           { city_code: 'JED', violation_code: '808', violation_name: 'Renting or dealing a parking space without a valid permit', ticket_charges: 'SAR 300', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
//           { city_code: 'JED', violation_code: '809', violation_name: 'Parked outside allowed times', ticket_charges: 'SAR 150', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
//           { city_code: 'JED', violation_code: '810', violation_name: 'Parked in violation of posted signs', ticket_charges: 'SAR 150', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
//           { city_code: 'JED', violation_code: '811', violation_name: 'Parked on a fire hydrant bay', ticket_charges: 'SAR 250', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
//         ],
//       },
//     },

//     assetsFallback: {
//       table_key: 'jeddah_on_street_assets',
//       title: 'Jeddah On-Street',
//       data: {
//         groups: makeAssetGroups({
//           ticketDispenser: '-', ticketVerifier: '3',
//           apms: '-', pinPad: '-', cardReader: '-', bContactless: '-',
//           rfidReader: '6', ipBarrier: '-', anprCamera: '-',
//           slidingGate: '6', right: '3', left: '3',
//           pnds: '389', tpalBnaLarge: '46', tpalTx: '251', tpalV2: '92',
//           enfDevice: '110', oukitelWp2: '3', doogeeV10: '107',
//           printer: '93', pr3: '7', sewoo: '8', bixolon: '78',
//           towTruck: '28', clampVehicle: '11', supportVehicle: '3',
//         }),
//       },
//     },
//   },

//   // ── Jeddah Off-Street ────────────────────────────────────────────────
//   jeddah_off_street_profile: {
//     profileKey: 'jeddah_off_street_profile',
//     assetsKey: 'jeddah_off_street_assets',
//     pageType: 'off_street',

//     profileFallback: {
//       table_key: 'jeddah_off_street_profile',
//       title: 'Jeddah Off-Street Profile',
//       data: {
//         total_bays: { label: 'Total Off Street Car Park Bays', value: '403' },
//         contract_term: { value: '25 years' },
//         contract_period: { start_date: '12.11.2014', end_date: '11.11.2039' },
//         operational_hours: { value: '24', unit: 'Hours Per day' },
//         rate_per_hour: { value: '3.00 plus 15% vat' },
//         membership_rates: { value: '' },
//       },
//     },

//     assetsFallback: {
//       table_key: 'jeddah_off_street_assets',
//       title: 'Jeddah Off-Street',
//       data: {
//         groups: makeAssetGroups({
//           ticketDispenser: '5', ticketVerifier: '4', evDipG100: '-',
//           apms: '4', pinPad: '3', cardReader: '3', bContactless: '3',
//           rfidReader: '10', ipBarrier: '9', anprCamera: '9',
//           slidingGate: '-', right: '-', left: '-',
//           pnds: '-', tpalBnaLarge: '-', tpalTx: '-', tpalV2: '-',
//           enfDevice: '-', printer: '-',
//           towTruck: '-', clampVehicle: '-', supportVehicle: '-',
//         }),
//       },
//     },
//   },
// };

// // ═══════════════════════════════════════════════════════════════════════
// // OFF-STREET PRICING TABLE (Hindawiya Bridge)
// // ═══════════════════════════════════════════════════════════════════════
// const HINDAWIYA_ROWS_DEFAULT = [
//   { sno: 1, bridge: 'A', rfid: 100, monthly_large: 800, monthly_small: 600, hourly_big: 10, hourly_small: 3 },
//   { sno: 2, bridge: 'B', rfid: 100, monthly_large: 500, monthly_small: 200, hourly_big: 10, hourly_small: 3 },
//   { sno: 3, bridge: 'C', rfid: 100, monthly_large: 600, monthly_small: 200, hourly_big: 10, hourly_small: 3 },
//   { sno: 4, bridge: 'D', rfid: 100, monthly_large: 600, monthly_small: 350, hourly_big: 10, hourly_small: 3 },
//   { sno: 5, bridge: 'E', rfid: 100, monthly_large: 500, monthly_small: 300, hourly_big: 10, hourly_small: 3 },
//   { sno: 6, bridge: 'H', rfid: 100, monthly_large: 500, monthly_small: 200, hourly_big: 10, hourly_small: 3 },
//   { sno: 7, bridge: 'AR', rfid: 100, monthly_large: '-', monthly_small: 300, hourly_big: '-', hourly_small: 3 },
// ];

// // ═══════════════════════════════════════════════════════════════════════
// // MAIN COMPONENT
// // ═══════════════════════════════════════════════════════════════════════
// const JeddahProfile = ({ page, year = '', monthNumber = '', contract = '' }) => {
//   const cfg = JEDDAH_PROFILE_CONFIG[page?.type];
//   if (!cfg) return null;

//   const hasFetchedRef = useRef(false);
//   const saveRef = useRef(null);

//   const [isSaving, setIsSaving] = useState(false);
//   const [profileTable, setProfileTable] = useState(cfg.profileFallback);
//   const [assetsTable, setAssetsTable] = useState(cfg.assetsFallback);
//   const [violationTable, setViolationTable] = useState(cfg.violationFallback || null);
//   const [hindawiyaRows, setHindawiyaRows] = useState(HINDAWIYA_ROWS_DEFAULT);

//   const { enqueue } = useApiQueue();

//   // ── Refs for latest state (Stale State Fix) ─────────────────────────────
//   const profileRef = useRef(null);
//   const assetsRef = useRef(null);
//   const violationRef = useRef(null);
//   const hindawiyaRef = useRef(null);

//   // Sync refs with latest state
//   useEffect(() => { profileRef.current = profileTable; }, [profileTable]);
//   useEffect(() => { assetsRef.current = assetsTable; }, [assetsTable]);
//   useEffect(() => { violationRef.current = violationTable; }, [violationTable]);
//   useEffect(() => { hindawiyaRef.current = hindawiyaRows; }, [hindawiyaRows]);

//   // ── Fetch ─────────────────────────────────────────────────────────────
//   useEffect(() => {
//     if (hasFetchedRef.current) return;
//     hasFetchedRef.current = true;
//     fetchData();
//   }, [year, monthNumber, contract]);

//   const fetchData = async () => {
//     try {
//       const res = await enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber }));
//       if (!res?.success) return;
//       const data = res?.data || [];
//       const find = (key, fb) => data.find(t => t.table_key === key) || fb;

//       setProfileTable(find(cfg.profileKey, cfg.profileFallback));
//       setAssetsTable(find(cfg.assetsKey, cfg.assetsFallback));
//       if (cfg.violationKey) setViolationTable(find(cfg.violationKey, cfg.violationFallback));

//       // Hindawiya rows (off-street only)
//       const hindawiyaData = data.find(t => t.table_key === 'jeddah_hindawiya_pricing');
//       if (hindawiyaData?.data?.rows) setHindawiyaRows(hindawiyaData.data.rows);
//     } catch (err) {
//       console.error('Fetch error:', err);
//     }
//   };

//   // ── Auto-save ─────────────────────────────────────────────────────────
//   const autoSave = () => {
//     if (saveRef.current) clearTimeout(saveRef.current);
//     saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
//   };

//   // ── Fixed saveToAPI using Refs ────────────────────────────────────────────
//   const saveToAPI = async () => {
//     try {
//       setIsSaving(true);

//       const tables = [
//         {
//           table_key: profileRef.current?.table_key,
//           title: profileRef.current?.title,
//           data: profileRef.current?.data
//         },
//         {
//           table_key: assetsRef.current?.table_key,
//           title: assetsRef.current?.title,
//           data: assetsRef.current?.data
//         },
//       ];

//       if (violationRef.current) {
//         tables.push({
//           table_key: violationRef.current.table_key,
//           title: violationRef.current.title,
//           data: violationRef.current.data
//         });
//       }

//       // Hindawiya Bridge Pricing (only for off-street)
//       if (hindawiyaRef.current && cfg.pageType === 'off_street') {
//         tables.push({
//           table_key: 'jeddah_hindawiya_pricing',
//           title: 'Hindawiya Bridge Pricing',
//           data: { rows: hindawiyaRef.current }
//         });
//       }

//       const res = await apiCall('POST', '/boardpack/add-tables-data', {
//         contract,
//         year,
//         month: monthNumber,
//         created_by: 1,
//         tables,
//       });

//       if (!res?.success) throw new Error(res?.message || 'Save failed');
//     } catch (err) {
//       console.error('Save error:', err);
//       toast.error('Failed to save changes');
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   // ── Patch helpers ─────────────────────────────────────────────────────
//   const patchProfile = (field, subField, value) => {
//     setProfileTable(prev => ({
//       ...prev,
//       data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
//     }));
//     autoSave();
//   };

//   const handleViolationCell = (rIdx, key, value) => {
//     setViolationTable(prev => ({
//       ...prev,
//       data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
//     }));
//     autoSave();
//   };

//   const handleHindawiyaCell = (rIdx, key, value) => {
//     setHindawiyaRows(prev => prev.map((r, i) => i === rIdx ? { ...r, [key]: value } : r));
//     autoSave();
//   };

//   const handleAssetSubCount = (flatIdx, value) => {
//     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   const handleAssetTotalCount = (flatIdx, value) => {
//     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   const pd = profileTable.data;
//   const flatAssets = groupsToFlat(assetsTable.data.groups);
//   const pageType = cfg.pageType;

//   // ═══════════════════════════════════════════════════════════════════
//   // RENDER
//   // ═══════════════════════════════════════════════════════════════════
//   return (
//     <div className="min-h-screen p-4 md:p-6 lg:p-8 bg-white">

//       {/* ── Header ── */}
//       {/* <div className="flex justify-between items-center mb-3">
//         <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
//       </div> */}

//       <div className="flex justify-between items-center mb-3">
//         <div className="ml-2">
//           <img src={LOGO} alt="Digital City Logo" style={{ height: '50px', objectFit: 'contain' }} />
//         </div>
//         <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
//       </div>

//       {/* ══════════════════════════════════════
//           ON-STREET PAGE
//       ══════════════════════════════════════ */}
//       {pageType === 'on_street' && (
//         <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">
//           {/* LEFT */}
//           <div className="flex-1 pr-4">

//             {/* Activities */}
//             <div className="mb-5">
//               <p className="text-[16px] font-bold mb-10">Activities:</p>
//               <div className="flex gap-8">
//                 {['On Street', 'Enforcement'].map(label => (
//                   <div key={label} className="flex flex-col items-center gap-2">
//                     <div className="w-40 h-28 mb-4 flex items-center justify-center">
//                       {label === 'On Street' && <img src={OnStreet} alt="On Street" style={{ height: '180px', objectFit: 'contain' }} />}
//                       {label === 'Enforcement' && <img src={Enforcement} alt="Enforcement" style={{ height: '180px', objectFit: 'contain' }} />}
//                     </div>
//                     {/* <span className="text-[13px] font-semibold">{label}</span> */}
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* On Street icon + profile info */}
//             <div className="flex items-start gap-3 mb-5">
//               <div className="w-10 h-8  flex items-center justify-center">
//                 <img src={OnStreet} alt="On Street" style={{ height: '50px', objectFit: 'contain' }} />
//               </div>
//               <div className="flex flex-col gap-1.5">

//                 {/* Total Bays */}
//                 <span className="text-[12px]">
//                   {pd.total_bays?.label}{' '}
//                   <strong>
//                     Bays{' '}
//                     <input type="text" value={pd.total_bays?.value || ''}
//                       onChange={e => patchProfile('total_bays', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-20" />
//                   </strong>
//                 </span>

//                 {/* Contract Term */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px]  gap-1">
//                     Contract term{' '}
//                     <strong><input type="text" value={pd.contract_term?.value || ''}
//                       onChange={e => patchProfile('contract_term', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-13" /></strong>
//                     {'; start date '}
//                     <strong><input type="text" value={pd.contract_period?.start_date || ''}
//                       onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-15" /></strong>
//                     {' to '}
//                     <strong><input type="text" value={pd.contract_period?.end_date || ''}
//                       onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24" /></strong>
//                   </span>
//                 </div>

//                 {/* Operational Hours */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px] flex items-center flex-wrap gap-1">
//                     Operational Hours{' '}
//                     <strong><input type="text" value={pd.operational_hours?.value || ''}
//                       onChange={e => patchProfile('operational_hours', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-25" /></strong>
//                     {' '}
//                     <strong><input type="text" value={pd.operational_hours?.from || ''}
//                       onChange={e => patchProfile('operational_hours', 'from', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-9" /></strong>
//                     {' Hours to '}
//                     <strong><input type="text" value={pd.operational_hours?.to || ''}
//                       onChange={e => patchProfile('operational_hours', 'to', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-8" /></strong>
//                     {' Hours'}
//                   </span>
//                 </div>

//                 {/* Rate Per Hour */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px]">
//                     Rate per Hour{' '}
//                     <strong><input type="text" value={pd.rate_per_hour?.value || ''}
//                       onChange={e => patchProfile('rate_per_hour', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-48" /></strong>
//                   </span>
//                 </div>

//                 {/* Ramadan Hours */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px]">
//                     Ramadhan Hours –{' '}
//                     <input type="text" value={pd.ramadan_hours?.value || ''}
//                       onChange={e => patchProfile('ramadan_hours', 'value', e.target.value)}
//                       className=" outline-none bg-transparent !border-0 text-[12px] w-100" />
//                   </span>
//                 </div>

//                 {/* Assets Deployed */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//                   <span className="text-[12px]">Assets Deployed</span>
//                 </div>
//               </div>
//             </div>

//             {/* Violation Table */}
//             {violationTable && (
//               <div className="">
//                 <table className="!border-collapse text-[8px]">
//                   <thead>
//                     <tr>
//                       {[
//                         { label: 'City_Id', w: '55px' },
//                         { label: 'Violation_Id', w: '55px' },
//                         { label: 'Violation_Name_En', w: '210px' },
//                         { label: 'Ticket_Charges', w: '65px' },
//                         { label: 'Tow_Charges', w: '65px' },
//                         { label: 'Clamp_Charges', w: '65px' },
//                       ].map(({ label, w }) => (
//                         <th key={label} className="!border !border-black px-2 py-1 font-bold text-center bg-gray-300" style={{ minWidth: w }}>
//                           {label}
//                         </th>
//                       ))}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {violationTable.data.rows.map((row, rIdx) => (
//                       <tr key={rIdx} className={''}>
//                         {[
//                           { key: 'city_code', w: '55px' },
//                           { key: 'violation_code', w: '55px' },
//                           { key: 'violation_name', w: '210px', isLong: true },
//                           { key: 'ticket_charges', w: '65px' },
//                           { key: 'tow_charges', w: '65px' },
//                           { key: 'clamp_charges', w: '65px' },
//                         ].map(({ key, w, isLong }) => (
//                           <td key={key} className="!border !border-black px-1.5 py-0.5 align-top">

//                             {isLong ? (
//                               <textarea
//                                 value={row[key] || ''}
//                                 onChange={e => handleViolationCell(rIdx, key, e.target.value)}
//                                 rows={1}
//                                 className="!border-0 bg-transparent outline-none text-[8px] resize-none overflow-hidden w-full"
//                                 style={{ minWidth: w }}
//                                 onInput={(e) => {
//                                   e.target.style.height = 'auto';
//                                   e.target.style.height = e.target.scrollHeight + 'px';
//                                 }}
//                               />
//                             ) : (
//                               <input
//                                 type="text"
//                                 value={row[key] || ''}
//                                 onChange={e => handleViolationCell(rIdx, key, e.target.value)}
//                                 className="!border-0 bg-transparent outline-none text-[8px] text-center"
//                                 style={{ width: w }}
//                               />
//                             )}

//                           </td>
//                         ))}
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             )}
//           </div>

//           {/* RIGHT — Assets */}
//           <AssetsPanel assetsTable={assetsTable} flatAssets={flatAssets}
//             onSubCount={handleAssetSubCount} onTotalCount={handleAssetTotalCount} />
//         </div>
//       )}

//       {/* ══════════════════════════════════════
//           OFF-STREET PAGE
//       ══════════════════════════════════════ */}
//       {pageType === 'off_street' && (
//         <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">
//           {/* LEFT */}
//           <div className="flex-1 pr-4">
//             <div className="flex items-start gap-4 mb-4">
//               {/* Car Park icon */}
//               <div className="flex flex-col items-center rounded bg-gray-50 w-20 flex-shrink-0">
//                 <img src={CarPark} alt="Car Park" style={{ height: '50px', objectFit: 'contain' }} />
//               </div>

//               <div className="flex flex-col gap-1.5">
//                 {/* Total Bays */}
//                 <span className="text-[12px]">
//                   {pd.total_bays?.label}{' '}
//                   <strong>
//                     <input type="text" value={pd.total_bays?.value || ''}
//                       onChange={e => patchProfile('total_bays', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-20"
//                       placeholder="............" />
//                   </strong>
//                 </span>

//                 {/* Contract Term */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px] flex items-center flex-wrap gap-1">
//                     Contract term{' '}
//                     <strong><input type="text" value={pd.contract_term?.value || ''}
//                       onChange={e => patchProfile('contract_term', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-13"
//                       placeholder="........." /></strong>
//                     {'; start date '}
//                     <strong><input type="text" value={pd.contract_period?.start_date || ''}
//                       onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16"
//                       placeholder="................" /></strong>
//                     {' to '}
//                     <strong><input type="text" value={pd.contract_period?.end_date || ''}
//                       onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-28"
//                       placeholder="................" /></strong>
//                   </span>
//                 </div>

//                 {/* Operational Hours */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px] flex items-center flex-wrap gap-1">
//                     Operational Hours{' '}
//                     <strong><input type="text" value={pd.operational_hours?.value || ''}
//                       onChange={e => patchProfile('operational_hours', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-4"
//                       placeholder="........" /></strong>
//                     {' '}
//                     <strong><input type="text" value={pd.operational_hours?.unit || ''}
//                       onChange={e => patchProfile('operational_hours', 'unit', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-32"
//                       placeholder="Hours Per day" /></strong>
//                   </span>
//                 </div>

//                 {/* Rate Per Hour */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px]">
//                     Rate per Hour <strong>SAR </strong>
//                     <strong><input type="text" value={pd.rate_per_hour?.value || ''}
//                       onChange={e => patchProfile('rate_per_hour', 'value', e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-[12px] w-36"
//                       placeholder="........" /></strong>
//                   </span>
//                 </div>

//                 {/* Assets Deployed */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//                   <span className="text-[12px]">Assets Deployed</span>
//                 </div>

//                 {/* Membership Rates */}
//                 <div className="flex items-center gap-2 ml-4">
//                   <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//                   <span className="text-[12px]">
//                     Membership Rates:{' '}
//                     <input type="text" value={pd.membership_rates?.value || ''}
//                       onChange={e => patchProfile('membership_rates', 'value', e.target.value)}
//                       className="outline-none bg-transparent !border-0 text-[12px] w-48" />
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* Hindawiya Bridge Pricing Table */}
//             <div className="mt-4 ">

//               <table className="!border-collapse text-[8px] w-full">
//                 <thead>

//                   {/* 🔥 TOP ROW (Title + Monthly/Hourly) */}
//                   <tr>
//                     <th className="!border !border-black border-t-transparent! border-l-transparent! text-[11px] px-2 py-1 font-bold text-center " colSpan={3}>
//                       Hindawiya Bridge- Prices EX VAT
//                     </th>


//                     <th className="!border !border-black px-2 py-1 bg-gray-300 font-bold text-center">Monthly</th>
//                     <th className="!border !border-black px-2 py-1 bg-gray-300 font-bold text-center">Monthly</th>
//                     <th className="!border !border-black px-2 py-1 bg-gray-300 font-bold text-center">Hourly</th>
//                     <th className="!border !border-black px-2 py-1 bg-gray-300 font-bold text-center">Hourly</th>
//                   </tr>

//                   {/* 🔥 SECOND ROW */}
//                   <tr>
//                     <th className="!border !border-black px-2 py-1 bg-gray-300 font-bold text-center" style={{ minWidth: '35px' }}>
//                       #S.NO
//                     </th>
//                     <th className="!border !border-black px-2 py-1 bg-gray-300 font-bold text-center" style={{ minWidth: '60px' }}>
//                       #Bridge Location
//                     </th>
//                     <th className="!border !border-black px-2 py-1 bg-gray-300 font-bold text-center" style={{ minWidth: '45px' }}>
//                       RFID
//                     </th>

//                     {[
//                       { label: 'Membership\nLarge Vehicle', w: '45px' },
//                       { label: 'Membership\nSmall Vehicle', w: '45px' },
//                       { label: 'Casual Parking\nBig Vehicle', w: '45px' },
//                       { label: 'Casual Parking\nSmall Vehicle', w: '45px' },
//                     ].map(({ label, w }) => (
//                       <th
//                         key={label}
//                         className="!border !border-black px-1 py-1 bg-gray-300 font-bold text-center whitespace-pre-line"
//                         style={{ minWidth: w }}
//                       >
//                         {label}
//                       </th>
//                     ))}
//                   </tr>

//                 </thead>
//                 <tbody>
//                   {hindawiyaRows.map((row, rIdx) => (
//                     <tr key={rIdx} className={''}>
//                       {[

//                         { key: 'sno', w: '35px' },
//                         { key: 'bridge', w: '60px' },
//                         { key: 'rfid', w: '45px' },
//                         { key: 'monthly_large', w: '75px' },
//                         { key: 'monthly_small', w: '75px' },
//                         { key: 'hourly_big', w: '75px' },
//                         { key: 'hourly_small', w: '75px' },
//                       ].map(({ key, w }) => (
//                         <td key={key} className="!border !border-black px-1.5 py-0.5 text-center">
//                           <input type="text" value={String(row[key] ?? '')}
//                             onChange={e => handleHindawiyaCell(rIdx, key, e.target.value)}
//                             className="!border-0 bg-transparent outline-none text-[8px] text-center" style={{ width: w }} />
//                         </td>
//                       ))}
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* RIGHT — Assets */}
//           <AssetsPanel assetsTable={assetsTable} flatAssets={flatAssets}
//             onSubCount={handleAssetSubCount} onTotalCount={handleAssetTotalCount} />
//         </div>
//       )}

//       {/* Saving indicator */}
//       {/* {isSaving && (
//         <div className="fixed bottom-4 right-4 bg-blue-600 text-white text-xs px-3 py-1.5 rounded shadow-lg z-50">
//           Saving...
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default JeddahProfile;













import React, { useState, useRef, useEffect } from 'react';
import { apiCall } from '@/api/apiCall';
import { toast } from 'sonner';
import { useApiQueue } from '@/hooks/useApiQueue';
import LOGO from '@/assets/img/Jeddah_1.png';
import CarPark from '@/assets/img/TaifContract-carPark.png';
import OnStreet from '@/assets/img/TaifContract-onStreet.png';
import Enforcement from '@/assets/img/TaifContract-Enforcement.png';
import { AssetsPanel } from '../../components/shared/AssetsPanel';
import { API_CALL_TIME } from '@/constants/constant';

// ═══════════════════════════════════════════════════════════════════════
// HELPERS
// ═══════════════════════════════════════════════════════════════════════
const groupsToFlat = (groups = []) => {
  const result = [];
  groups.forEach(g => {
    result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
    (g.items || []).forEach(item => {
      result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
    });
  });
  return result;
};

const flatToGroups = (flat) => {
  const groups = [];
  let cur = null;
  flat.forEach(a => {
    if (a.isCategory) {
      if (cur) groups.push(cur);
      cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
    } else if (cur) {
      cur.items.push({ item_name: a.name, qty: a.subCount || '' });
    }
  });
  if (cur) groups.push(cur);
  return groups;
};

// ═══════════════════════════════════════════════════════════════════════
// ASSET GROUPS HELPER
// ═══════════════════════════════════════════════════════════════════════
function makeAssetGroups(o = {}) {
  return [
    { group_name: 'Ticket Dispenser', group_total_qty: o.ticketDispenser ?? '-', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '-' }, { item_name: 'G100 32 Bit', qty: '-' }] },
    { group_name: 'Ticket Verifier', group_total_qty: o.ticketVerifier ?? '', items: [{ item_name: 'EV DIP G100', qty: o.evDipG100 ?? '-' }, { item_name: 'EV G100 64 Bit', qty: '-' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
    { group_name: "APM's", group_total_qty: o.apms ?? '-', items: [{ item_name: 'APM ETS-70', qty: '-' }, { item_name: 'APM ETS-100', qty: '-' }] },
    { group_name: 'PIN Pad', group_total_qty: o.pinPad ?? '-', items: [{ item_name: 'IUP 250', qty: '-' }] },
    { group_name: 'Card Reader', group_total_qty: o.cardReader ?? '-', items: [{ item_name: 'IUR250', qty: '-' }] },
    { group_name: 'B-Contactless', group_total_qty: o.bContactless ?? '-', items: [{ item_name: 'IUC 150', qty: '-' }] },
    { group_name: 'RFID Reader', group_total_qty: o.rfidReader ?? '-', items: [] },
    { group_name: 'IP Barrier', group_total_qty: o.ipBarrier ?? '-', items: [] },
    { group_name: 'ANPR CAMERA', group_total_qty: o.anprCamera ?? '-', items: [{ item_name: 'ARH', qty: '-' }, { item_name: 'Luminera', qty: '-' }] },
    { group_name: 'Sliding Gate', group_total_qty: o.slidingGate ?? '-', items: [{ item_name: 'RIGHT', qty: o.right ?? '-' }, { item_name: 'LEFT', qty: o.left ?? '-' }] },
    { group_name: "PND's", group_total_qty: o.pnds ?? '-', items: [{ item_name: 'TPAL- BNA Large', qty: o.tpalBnaLarge ?? '-' }, { item_name: 'T-PAL TX', qty: o.tpalTx ?? '-' }, { item_name: 'T-PAL V2', qty: o.tpalV2 ?? '-' }] },
    { group_name: 'Pound Cahier Device', group_total_qty: '-', items: [{ item_name: 'CN-50', qty: '-' }] },
    { group_name: 'Driver Device', group_total_qty: '-', items: [{ item_name: 'CN-51', qty: '-' }] },
    { group_name: 'Enf Device', group_total_qty: o.enfDevice ?? '-', items: [{ item_name: 'Oukitel WP 2', qty: o.oukitelWp2 ?? '-' }, { item_name: 'Doogee V10', qty: o.doogeeV10 ?? '-' }] },
    { group_name: 'Validation', group_total_qty: '-', items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
    { group_name: 'Printer', group_total_qty: o.printer ?? '-', items: [{ item_name: 'PR-3', qty: o.pr3 ?? '-' }, { item_name: 'SEWOO', qty: o.sewoo ?? '-' }, { item_name: 'BIXOLON', qty: o.bixolon ?? '-' }] },
    { group_name: 'Tow Truck', group_total_qty: o.towTruck ?? '-', items: [] },
    { group_name: 'Clamp Vehicle', group_total_qty: o.clampVehicle ?? '-', items: [] },
    { group_name: 'Support Vehicle', group_total_qty: o.supportVehicle ?? '-', items: [] },
  ];
}

// ═══════════════════════════════════════════════════════════════════════
// CONFIG
// ═══════════════════════════════════════════════════════════════════════
const JEDDAH_PROFILE_CONFIG = {

  // ── Jeddah On-Street ─────────────────────────────────────────────────
  jeddah_on_street_profile: {
    profileKey: 'jeddah_on_street_profile',
    violationKey: 'jeddah_on_street_violations',
    assetsKey: 'jeddah_on_street_assets',
    pageType: 'on_street',

    profileFallback: {
      table_key: 'jeddah_on_street_profile',
      title: 'Jeddah On Street - Profile',
      data: {
        total_bays: { label: 'Total On-Street Parking', value: '8,858' },
        contract_term: { value: '25 years' },
        contract_period: { start_date: '12.11.2014', end_date: '11.11.2039' },
        operational_hours: { value: '15 Hours Per day', from: '0800', to: '2300' },
        rate_per_hour: { value: 'SAR 4.00 plus 15% vat' },
        ramadan_hours: { value: '11:00 Hours to 17:00 Hours & 21:00 Hours to 03:00 Hours' },
      },
    },

    violationFallback: {
      table_key: 'jeddah_on_street_violations',
      title: 'Jeddah On Street Violations',
      data: {
        rows: [
          { city_code: 'JED', violation_code: '10', violation_name: 'Parked without displaying a valid parking ticket', ticket_charges: 'SAR 150', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
          { city_code: 'JED', violation_code: '11', violation_name: 'Parking a vehicle larger than the marked space', ticket_charges: 'SAR 150', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
          { city_code: 'JED', violation_code: '12', violation_name: 'Parked with a wheel on pedestrian areas/road', ticket_charges: 'SAR 100', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
          { city_code: 'JED', violation_code: '13', violation_name: 'Not parked within space markings', ticket_charges: 'SAR 100', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
          { city_code: 'JED', violation_code: '14', violation_name: 'Parked/overhanging a loading/unloading space', ticket_charges: 'SAR 150', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
          { city_code: 'JED', violation_code: '15', violation_name: 'Parked in a space for Special Needs without a valid permit', ticket_charges: 'SAR 150', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
          { city_code: 'JED', violation_code: '16', violation_name: 'Parked without at least one license plate', ticket_charges: 'SAR 300', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
          { city_code: 'JED', violation_code: '21', violation_name: 'Park in Sand Areas', ticket_charges: 'SAR 100', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
          { city_code: 'JED', violation_code: '22', violation_name: 'Obstructing an authorized personnel from executing their duties', ticket_charges: 'SAR 300', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
          { city_code: 'JED', violation_code: '801', violation_name: 'Parked within the road and traffic areas', ticket_charges: 'SAR 150', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
          { city_code: 'JED', violation_code: '802', violation_name: 'Parked on pedestrian or buildings entries', ticket_charges: 'SAR 200', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
          { city_code: 'JED', violation_code: '803', violation_name: 'Parked on the pavement or on a pedestrian area', ticket_charges: 'SAR 100', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
          { city_code: 'JED', violation_code: '804', violation_name: 'Parked facing the opposite direction of traffic flow', ticket_charges: 'SAR 150', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
          { city_code: 'JED', violation_code: '805', violation_name: 'Parked in an officially reserved space', ticket_charges: 'SAR 100', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
          { city_code: 'JED', violation_code: '806', violation_name: 'Parked in a suspended space/temporary out of use', ticket_charges: 'SAR 150', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
          { city_code: 'JED', violation_code: '807', violation_name: 'Placing obstacles or reservations on the parking space', ticket_charges: 'SAR 150', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
          { city_code: 'JED', violation_code: '808', violation_name: 'Renting or dealing a parking space without a valid permit', ticket_charges: 'SAR 300', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
          { city_code: 'JED', violation_code: '809', violation_name: 'Parked outside allowed times', ticket_charges: 'SAR 150', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
          { city_code: 'JED', violation_code: '810', violation_name: 'Parked in violation of posted signs', ticket_charges: 'SAR 150', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
          { city_code: 'JED', violation_code: '811', violation_name: 'Parked on a fire hydrant bay', ticket_charges: 'SAR 250', tow_charges: 'SAR 300', clamp_charges: 'SAR 75' },
        ],
      },
    },

    assetsFallback: {
      table_key: 'jeddah_on_street_assets',
      title: 'Jeddah On-Street',
      data: {
        groups: makeAssetGroups({
          ticketDispenser: '-', ticketVerifier: '3',
          apms: '-', pinPad: '-', cardReader: '-', bContactless: '-',
          rfidReader: '6', ipBarrier: '-', anprCamera: '-',
          slidingGate: '6', right: '3', left: '3',
          pnds: '389', tpalBnaLarge: '46', tpalTx: '251', tpalV2: '92',
          enfDevice: '110', oukitelWp2: '3', doogeeV10: '107',
          printer: '93', pr3: '7', sewoo: '8', bixolon: '78',
          towTruck: '28', clampVehicle: '11', supportVehicle: '3',
        }),
      },
    },
  },

  // ── Jeddah Off-Street ────────────────────────────────────────────────
  jeddah_off_street_profile: {
    profileKey: 'jeddah_off_street_profile',
    assetsKey: 'jeddah_off_street_assets',
    pageType: 'off_street',

    profileFallback: {
      table_key: 'jeddah_off_street_profile',
      title: 'Jeddah Off-Street Profile',
      data: {
        total_bays: { label: 'Total Off Street Car Park Bays', value: '403' },
        contract_term: { value: '25 years' },
        contract_period: { start_date: '12.11.2014', end_date: '11.11.2039' },
        operational_hours: { value: '24', unit: 'Hours Per day' },
        rate_per_hour: { value: '3.00 plus 15% vat' },
        membership_rates: { value: '' },
      },
    },

    assetsFallback: {
      table_key: 'jeddah_off_street_assets',
      title: 'Jeddah Off-Street',
      data: {
        groups: makeAssetGroups({
          ticketDispenser: '5', ticketVerifier: '4', evDipG100: '-',
          apms: '4', pinPad: '3', cardReader: '3', bContactless: '3',
          rfidReader: '10', ipBarrier: '9', anprCamera: '9',
          slidingGate: '-', right: '-', left: '-',
          pnds: '-', tpalBnaLarge: '-', tpalTx: '-', tpalV2: '-',
          enfDevice: '-', printer: '-',
          towTruck: '-', clampVehicle: '-', supportVehicle: '-',
        }),
      },
    },
  },
};

// ═══════════════════════════════════════════════════════════════════════
// OFF-STREET PRICING TABLE (Hindawiya Bridge)
// ═══════════════════════════════════════════════════════════════════════
const HINDAWIYA_ROWS_DEFAULT = [
  { sno: 1, bridge: 'A', rfid: 100, monthly_large: 800, monthly_small: 600, hourly_big: 10, hourly_small: 3 },
  { sno: 2, bridge: 'B', rfid: 100, monthly_large: 500, monthly_small: 200, hourly_big: 10, hourly_small: 3 },
  { sno: 3, bridge: 'C', rfid: 100, monthly_large: 600, monthly_small: 200, hourly_big: 10, hourly_small: 3 },
  { sno: 4, bridge: 'D', rfid: 100, monthly_large: 600, monthly_small: 350, hourly_big: 10, hourly_small: 3 },
  { sno: 5, bridge: 'E', rfid: 100, monthly_large: 500, monthly_small: 300, hourly_big: 10, hourly_small: 3 },
  { sno: 6, bridge: 'H', rfid: 100, monthly_large: 500, monthly_small: 200, hourly_big: 10, hourly_small: 3 },
  { sno: 7, bridge: 'AR', rfid: 100, monthly_large: '-', monthly_small: 300, hourly_big: '-', hourly_small: 3 },
];

// ═══════════════════════════════════════════════════════════════════════
// MAIN COMPONENT
// ═══════════════════════════════════════════════════════════════════════
const JeddahProfile = ({ page, year = '', month = '', monthNumber = '', contract = '' }) => {
  const cfg = JEDDAH_PROFILE_CONFIG[page?.type];
  if (!cfg) return null;

  const hasFetchedRef = useRef(false);
  const saveRef = useRef(null);

  const [isSaving, setIsSaving] = useState(false);
  
  // 🔥 State for second API (parking bays)
  const [parkingBaysData, setParkingBaysData] = useState(null);
  
  const [profileTable, setProfileTable] = useState(cfg.profileFallback);
  const [assetsTable, setAssetsTable] = useState(cfg.assetsFallback);
  const [violationTable, setViolationTable] = useState(cfg.violationFallback || null);
  const [hindawiyaRows, setHindawiyaRows] = useState(HINDAWIYA_ROWS_DEFAULT);

  const { enqueue } = useApiQueue();

  // 🔥 Effective total bays - second API se aayega
  const effectiveTotalBays = parkingBaysData?.total_bays ?? profileTable?.data?.total_bays?.value ?? '0';

  // ── Refs for latest state (Stale State Fix) ─────────────────────────────
  const profileRef = useRef(null);
  const assetsRef = useRef(null);
  const violationRef = useRef(null);
  const hindawiyaRef = useRef(null);

  // Sync refs with latest state
  useEffect(() => { profileRef.current = profileTable; }, [profileTable]);
  useEffect(() => { assetsRef.current = assetsTable; }, [assetsTable]);
  useEffect(() => { violationRef.current = violationTable; }, [violationTable]);
  useEffect(() => { hindawiyaRef.current = hindawiyaRows; }, [hindawiyaRows]);

  // ── Fetch BOTH APIs ─────────────────────────────────────────────────────────────
  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchAllData();
  }, [year, month, monthNumber, contract]);

  const fetchAllData = async () => {
    try {
      // 🔥 Second API params based on page type
      const isOnStreet = cfg.pageType === 'on_street';
      const secondApiParams = isOnStreet ? {
        contract: "0020001",
        year: year,
        month: month,
        device_onstreet: "JED",
        type: "on_street"
      } : {
        contract: "0020002",
        year: year,
        month: month,
        type: "off_street"
      };
      
      const [firstApiResponse, secondApiResponse] = await Promise.all([
        enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
        enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
      ]);

      // Process first API response
      if (firstApiResponse?.success) {
        const data = firstApiResponse?.data || [];
        const find = (key, fb) => data.find(t => t.table_key === key) || fb;

        setProfileTable(find(cfg.profileKey, cfg.profileFallback));
        setAssetsTable(find(cfg.assetsKey, cfg.assetsFallback));
        if (cfg.violationKey) setViolationTable(find(cfg.violationKey, cfg.violationFallback));

        // Hindawiya rows (off-street only)
        const hindawiyaData = data.find(t => t.table_key === 'jeddah_hindawiya_pricing');
        if (hindawiyaData?.data?.rows) setHindawiyaRows(hindawiyaData.data.rows);
      }

      // 🔥 Process second API response for parking bays
      if (secondApiResponse?.success && secondApiResponse?.data) {
        setParkingBaysData(secondApiResponse.data);
      } else {
        console.warn("Second API failed:", secondApiResponse?.message);
        setParkingBaysData(null);
      }
      
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  // ── Auto-save ─────────────────────────────────────────────────────────
  const autoSave = () => {
    if (saveRef.current) clearTimeout(saveRef.current);
    saveRef.current = setTimeout(saveToAPI, API_CALL_TIME);
  };

  // ── Fixed saveToAPI using Refs ────────────────────────────────────────────
  const saveToAPI = async () => {
    try {
      setIsSaving(true);

      const tables = [
        {
          table_key: profileRef.current?.table_key,
          title: profileRef.current?.title,
          data: profileRef.current?.data
        },
        {
          table_key: assetsRef.current?.table_key,
          title: assetsRef.current?.title,
          data: assetsRef.current?.data
        },
      ];

      if (violationRef.current) {
        tables.push({
          table_key: violationRef.current.table_key,
          title: violationRef.current.title,
          data: violationRef.current.data
        });
      }

      // Hindawiya Bridge Pricing (only for off-street)
      if (hindawiyaRef.current && cfg.pageType === 'off_street') {
        tables.push({
          table_key: 'jeddah_hindawiya_pricing',
          title: 'Hindawiya Bridge Pricing',
          data: { rows: hindawiyaRef.current }
        });
      }

      const res = await apiCall('POST', '/boardpack/add-tables-data', {
        contract,
        year,
        month: monthNumber,
        created_by: 1,
        tables,
      });

      if (!res?.success) throw new Error(res?.message || 'Save failed');
    } catch (err) {
      console.error('Save error:', err);
      toast.error('Failed to save changes');
    } finally {
      setIsSaving(false);
    }
  };

  // ── Patch helpers ─────────────────────────────────────────────────────
  const patchProfile = (field, subField, value) => {
    setProfileTable(prev => ({
      ...prev,
      data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
    }));
    autoSave();
  };

  const handleViolationCell = (rIdx, key, value) => {
    setViolationTable(prev => ({
      ...prev,
      data: { ...prev.data, rows: prev.data.rows.map((r, i) => i === rIdx ? { ...r, [key]: value } : r) },
    }));
    autoSave();
  };

  const handleHindawiyaCell = (rIdx, key, value) => {
    setHindawiyaRows(prev => prev.map((r, i) => i === rIdx ? { ...r, [key]: value } : r));
    autoSave();
  };

  const handleAssetSubCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current?.data?.groups || []).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  const handleAssetTotalCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current?.data?.groups || []).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  const pd = profileTable.data;
  const flatAssets = groupsToFlat(assetsTable.data.groups);
  const pageType = cfg.pageType;

  // ═══════════════════════════════════════════════════════════════════
  // RENDER
  // ═══════════════════════════════════════════════════════════════════
  return (
    <div className="min-h-screen p-8 bg-white">

      <div className="flex justify-between items-center mb-3">
        <div className="ml-2">
          <img src={LOGO} alt="Jeddah Logo" style={{ height: '50px', objectFit: 'contain' }} />
        </div>
        <h1 className="text-xl font-bold flex-1 text-center">{profileTable.title}</h1>
      </div>

      {/* ══════════════════════════════════════
          ON-STREET PAGE
      ══════════════════════════════════════ */}
      {pageType === 'on_street' && (
        <div className="flex flex-row gap-0 !border-2 !border-black p-3">
          {/* LEFT */}
          <div className="flex-1 pr-4">

            {/* Activities */}
            <div className="mb-5">
              <p className="text-[16px] font-bold mb-10">Activities:</p>
              <div className="flex gap-8">
                {['On Street', 'Enforcement'].map(label => (
                  <div key={label} className="flex flex-col items-center gap-2">
                    <div className="w-40 h-28 mb-4 flex items-center justify-center">
                      {label === 'On Street' && <img src={OnStreet} alt="On Street" style={{ height: '180px', objectFit: 'contain' }} />}
                      {label === 'Enforcement' && <img src={Enforcement} alt="Enforcement" style={{ height: '180px', objectFit: 'contain' }} />}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* On Street icon + profile info */}
            <div className="flex items-start gap-3 mb-5">
              <div className="w-10 h-8 flex items-center justify-center">
                <img src={OnStreet} alt="On Street" style={{ height: '50px', objectFit: 'contain' }} />
              </div>
              <div className="flex flex-col gap-1.5">

                {/* 🔥 READ-ONLY Total Bays */}
                <span className="text-[12px]">
                  {pd.total_bays?.label}{' '}
                  <strong>
                    Bays{' '}
                    <input 
                      type="text" 
                      value={effectiveTotalBays}
                      readOnly 
                      disabled
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-20 cursor-default" 
                    />
                  </strong>
                </span>

                {/* Contract Term - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px] gap-1">
                    Contract term{' '}
                    <strong><input type="text" value={pd.contract_term?.value || ''}
                      onChange={e => patchProfile('contract_term', 'value', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-13" /></strong>
                    {'; start date '}
                    <strong><input type="text" value={pd.contract_period?.start_date || ''}
                      onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-15" /></strong>
                    {' to '}
                    <strong><input type="text" value={pd.contract_period?.end_date || ''}
                      onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-[550px]" /></strong>
                  </span>
                </div>

                {/* Operational Hours - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px] flex items-center flex-wrap gap-1">
                    Operational Hours{' '}
                    <strong><input type="text" value={pd.operational_hours?.value || ''}
                      onChange={e => patchProfile('operational_hours', 'value', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-25" /></strong>
                    {' '}
                    <strong><input type="text" value={pd.operational_hours?.from || ''}
                      onChange={e => patchProfile('operational_hours', 'from', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-9" /></strong>
                    {' Hours to '}
                    <strong><input type="text" value={pd.operational_hours?.to || ''}
                      onChange={e => patchProfile('operational_hours', 'to', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-8" /></strong>
                    {' Hours'}
                  </span>
                </div>

                {/* Rate Per Hour - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px]">
                    Rate per Hour{' '}
                    <strong><input type="text" value={pd.rate_per_hour?.value || ''}
                      onChange={e => patchProfile('rate_per_hour', 'value', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-[550px]" /></strong>
                  </span>
                </div>

                {/* Ramadan Hours - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px]">
                    Ramadhan Hours –{' '}
                    <input type="text" value={pd.ramadan_hours?.value || ''}
                      onChange={e => patchProfile('ramadan_hours', 'value', e.target.value)}
                      className=" outline-none bg-transparent !border-0 text-[12px] w-[550px]" />
                  </span>
                </div>

                {/* Assets Deployed */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
                  <span className="text-[12px]">Assets Deployed</span>
                </div>
              </div>
            </div>

            {/* Violation Table - Editable */}
            {violationTable && (
              <div className="">
                <table className="!border-collapse text-[8px]">
                  <thead>
                    <tr>
                      {[
                        { label: 'City_Id', w: '55px' },
                        { label: 'Violation_Id', w: '55px' },
                        { label: 'Violation_Name_En', w: '210px' },
                        { label: 'Ticket_Charges', w: '65px' },
                        { label: 'Tow_Charges', w: '65px' },
                        { label: 'Clamp_Charges', w: '65px' },
                      ].map(({ label, w }) => (
                        <th key={label} className="!border !border-black px-2 py-1 font-bold text-center bg-gray-300" style={{ minWidth: w }}>
                          {label}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {violationTable.data.rows.map((row, rIdx) => (
                      <tr key={rIdx} className={''}>
                        {[
                          { key: 'city_code', w: '55px' },
                          { key: 'violation_code', w: '55px' },
                          { key: 'violation_name', w: '210px', isLong: true },
                          { key: 'ticket_charges', w: '65px' },
                          { key: 'tow_charges', w: '65px' },
                          { key: 'clamp_charges', w: '65px' },
                        ].map(({ key, w, isLong }) => (
                          <td key={key} className="!border !border-black px-1.5 py-0.5 align-top">
                            {isLong ? (
                              <textarea
                                value={row[key] || ''}
                                onChange={e => handleViolationCell(rIdx, key, e.target.value)}
                                rows={1}
                                className="!border-0 bg-transparent outline-none text-[8px] resize-none overflow-hidden w-full"
                                style={{ minWidth: w }}
                                onInput={(e) => {
                                  e.target.style.height = 'auto';
                                  e.target.style.height = e.target.scrollHeight + 'px';
                                }}
                              />
                            ) : (
                              <input
                                type="text"
                                value={row[key] || ''}
                                onChange={e => handleViolationCell(rIdx, key, e.target.value)}
                                className="!border-0 bg-transparent outline-none text-[8px] text-center"
                                style={{ width: w }}
                              />
                            )}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {/* RIGHT — Assets */}
          <AssetsPanel assetsTable={assetsTable} flatAssets={flatAssets}
            onSubCount={handleAssetSubCount} onTotalCount={handleAssetTotalCount} />
        </div>
      )}

      {/* ══════════════════════════════════════
          OFF-STREET PAGE
      ══════════════════════════════════════ */}
      {pageType === 'off_street' && (
        <div className="flex flex-row gap-0 !border-2 !border-black p-3">
          {/* LEFT */}
          <div className="flex-1 pr-4">
            <div className="flex items-start gap-4 mb-4">
              {/* Car Park icon */}
              <div className="flex flex-col items-center rounded bg-gray-50 w-20 flex-shrink-0">
                <img src={CarPark} alt="Car Park" style={{ height: '50px', objectFit: 'contain' }} />
              </div>

              <div className="flex flex-col gap-1.5">
                {/* 🔥 READ-ONLY Total Bays */}
                <span className="text-[12px]">
                  {pd.total_bays?.label}{' '}
                  <strong>
                    <input 
                      type="text" 
                      value={effectiveTotalBays}
                      readOnly 
                      disabled
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-20 cursor-default"
                      placeholder="............" />
                  </strong>
                </span>

                {/* Contract Term - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px] flex items-center flex-wrap gap-1">
                    Contract term{' '}
                    <strong><input type="text" value={pd.contract_term?.value || ''}
                      onChange={e => patchProfile('contract_term', 'value', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-13"
                      placeholder="........." /></strong>
                    {'; start date '}
                    <strong><input type="text" value={pd.contract_period?.start_date || ''}
                      onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-16"
                      placeholder="................" /></strong>
                    {' to '}
                    <strong><input type="text" value={pd.contract_period?.end_date || ''}
                      onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-[500px]"
                      placeholder="................" /></strong>
                  </span>
                </div>

                {/* Operational Hours - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px] flex items-center flex-wrap gap-1">
                    Operational Hours{' '}
                    <strong><input type="text" value={pd.operational_hours?.value || ''}
                      onChange={e => patchProfile('operational_hours', 'value', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-4"
                      placeholder="........" /></strong>
                    {' '}
                    <strong><input type="text" value={pd.operational_hours?.unit || ''}
                      onChange={e => patchProfile('operational_hours', 'unit', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-[550px]"
                      placeholder="Hours Per day" /></strong>
                  </span>
                </div>

                {/* Rate Per Hour - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px]">
                    Rate per Hour <strong>SAR </strong>
                    <strong><input type="text" value={pd.rate_per_hour?.value || ''}
                      onChange={e => patchProfile('rate_per_hour', 'value', e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-[12px] w-[550px]"
                      placeholder="........" /></strong>
                  </span>
                </div>

                {/* Assets Deployed */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
                  <span className="text-[12px]">Assets Deployed</span>
                </div>

                {/* Membership Rates - Editable */}
                <div className="flex items-center gap-2 ml-4">
                  <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
                  <span className="text-[12px]">
                    Membership Rates:{' '}
                    <input type="text" value={pd.membership_rates?.value || ''}
                      onChange={e => patchProfile('membership_rates', 'value', e.target.value)}
                      className="outline-none bg-transparent !border-0 text-[12px] w-[400px]" />
                  </span>
                </div>
              </div>
            </div>

            {/* Hindawiya Bridge Pricing Table - Editable */}
            <div className="mt-4">
              <table className="!border-collapse text-[8px] w-full">
                <thead>
                  <tr>
                    <th className="!border !border-black border-t-transparent! border-l-transparent! text-[11px] px-2 py-1 font-bold text-center" colSpan={3}>
                      Hindawiya Bridge- Prices EX VAT
                    </th>
                    <th className="!border !border-black px-2 py-1 bg-gray-300 font-bold text-center">Monthly</th>
                    <th className="!border !border-black px-2 py-1 bg-gray-300 font-bold text-center">Monthly</th>
                    <th className="!border !border-black px-2 py-1 bg-gray-300 font-bold text-center">Hourly</th>
                    <th className="!border !border-black px-2 py-1 bg-gray-300 font-bold text-center">Hourly</th>
                  </tr>
                  <tr>
                    <th className="!border !border-black px-2 py-1 bg-gray-300 font-bold text-center" style={{ minWidth: '35px' }}>#S.NO</th>
                    <th className="!border !border-black px-2 py-1 bg-gray-300 font-bold text-center" style={{ minWidth: '60px' }}>#Bridge Location</th>
                    <th className="!border !border-black px-2 py-1 bg-gray-300 font-bold text-center" style={{ minWidth: '45px' }}>RFID</th>
                    <th className="!border !border-black px-2 py-1 bg-gray-300 font-bold text-center" style={{ minWidth: '75px' }}>Membership<br />Large Vehicle</th>
                    <th className="!border !border-black px-2 py-1 bg-gray-300 font-bold text-center" style={{ minWidth: '75px' }}>Membership<br />Small Vehicle</th>
                    <th className="!border !border-black px-2 py-1 bg-gray-300 font-bold text-center" style={{ minWidth: '75px' }}>Casual Parking<br />Big Vehicle</th>
                    <th className="!border !border-black px-2 py-1 bg-gray-300 font-bold text-center" style={{ minWidth: '75px' }}>Casual Parking<br />Small Vehicle</th>
                  </tr>
                </thead>
                <tbody>
                  {hindawiyaRows.map((row, rIdx) => (
                    <tr key={rIdx} className={''}>
                      {[
                        { key: 'sno', w: '35px' },
                        { key: 'bridge', w: '60px' },
                        { key: 'rfid', w: '45px' },
                        { key: 'monthly_large', w: '75px' },
                        { key: 'monthly_small', w: '75px' },
                        { key: 'hourly_big', w: '75px' },
                        { key: 'hourly_small', w: '75px' },
                      ].map(({ key, w }) => (
                        <td key={key} className="!border !border-black px-1.5 py-0.5 text-center">
                          <input type="text" value={String(row[key] ?? '')}
                            onChange={e => handleHindawiyaCell(rIdx, key, e.target.value)}
                            className="!border-0 bg-transparent outline-none text-[8px] text-center" style={{ width: w }} />
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* RIGHT — Assets */}
          <AssetsPanel assetsTable={assetsTable} flatAssets={flatAssets}
            onSubCount={handleAssetSubCount} onTotalCount={handleAssetTotalCount} />
        </div>
      )}
    </div>
  );
};

export default JeddahProfile;